<template>
  <div ref="daily">
    <!-- <el-form  class="global-form3" :model="info" ref="info" label-position="left" label-width="120px"> -->
    <div class="header mb20 mt20">
      <div class="img_logo">
        <el-image v-if="info?.projectImg?.fileId" :src="info?.projectImg?.filePrefix + info?.projectImg?.fileUrl"
          :preview-src-list="[info?.projectImg?.filePrefix + info?.projectImg?.fileUrl]" fit="fill"></el-image>
        <img v-else src="../../assets/img/statement/project_default.png" alt="">
      </div>
      <div class="header_info">
        <div class="title">{{ info.projectName }}</div>
        <div class="date">
          <div class="item">
            <img src="../../assets/img/statement/daily_date.svg" alt="">日报日期： {{ info.dailyDate }}
          </div>
          <span>|</span>
          <div class="item">
            <img src="../../assets/img/statement/daily_person.svg" alt="">填报人： {{ info.dailyUserName }}
          </div>
          <span>|</span>
          <div class="item">
            <img src="../../assets/img/statement/Filling_time.svg" alt="">填报时间： {{ info.ctime }}
          </div>
        </div>
        <div v-if="info.avgGrade" class="evaluation">
          业主评分：
          <div class="star" v-for="(index) in [1, 2, 3, 4, 5]" :key="index">
            <img
              :src="index <= info.avgGrade ? require('../../assets/img/statement/good.svg') : require('../../assets/img/statement/none.svg')"
              alt="">
          </div>
          <div class="grade">{{ info.avgGrade }}</div>
        </div>
        <div v-else class="evaluation">
          业主评分：暂未评价
        </div>
      </div>
    </div>
    <div class="selction">
      <div class="selction_title">
        <div class="left">
          <img src="@/assets/img/statement/manage_user.svg" />
          现场管理人员
        </div>
      </div>
      <div class="selction_info">
        <div class="user_list">
          <div class="user_item" v-for="(item) in info.manageUserList" :key="item.manageUserId">
            <img src="../../assets/img/statement/user_default.png" alt="">
            {{ item.manageUserName }}
          </div>
        </div>
      </div>
    </div>
    <div class="selction">
      <div class="selction_title">
        <div class="left">
          <img src="@/assets/img/statement/attendance.svg" />
          劳务考勤
        </div>
      </div>
      <div class="selction_info">
        <!-- v-if="attendanceList.length" -->
        <!-- <div > -->
        <el-table class="global-table global-tables custom-table-border" max-height="208" :data="attendanceList" border
          :cell-style="themeColor" ref="table_tomorrow">
          <el-table-column label="班组名称" show-overflow-tooltip prop="teamName"></el-table-column>
          <el-table-column label="班组负责人" show-overflow-tooltip prop="teamLeader"></el-table-column>
          <el-table-column label="上班签到人数" show-overflow-tooltip prop="onSignNum"></el-table-column>
          <el-table-column label="下班签到人数" show-overflow-tooltip prop="offSignNum"></el-table-column>
          <el-table-column label="签到情况" min-width="100px" show-overflow-tooltip prop="signStatus">
            <template v-slot="{ row }">
              <div style="display:flex;align-items:center;">
                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content">{{ row.signStatus | getStatusName2 }}</div>
                  <span>{{ row.signStatus | getStatusName }}</span>
                </el-tooltip>
                <img v-if="row.signStatus !== '1'" :src="require('../../assets/img/statement/exclamationPoint.svg')"
                  style="margin-left: 5px;" alt="" srcset="">
              </div>
            </template>
          </el-table-column>
          <el-table-column label="加班人数" show-overflow-tooltip prop="overtimeNum"></el-table-column>
          <el-table-column label="合计加班时长" show-overflow-tooltip prop="totalOvertimeHours"></el-table-column>
        </el-table>

        <!-- </div> -->
        <!-- <div v-else class="no-data" >
              <img src="@/assets/img/empty.svg"/>
          </div> -->

      </div>
    </div>
    <div class="selction">
      <div class="selction_title">
        <div class="left">
          <img src="@/assets/img/statement/order.svg" />
          养护工单
        </div>
      </div>
      <!-- v-if="orderIdList.length" -->
      <div class="selction_info  position_relative">
        <div class="count">
          今日工单数：{{ orderCount }}
        </div>
        <div id="conserve_echars" ref="conserve_echars">
        </div>
        <el-table class="global-table global-tables my-table custom-table-border" max-height="208" :data="orderIdList"
          border ref="table_order">
          <el-table-column label="工单详情" show-overflow-tooltip prop="orderContent"></el-table-column>
          <el-table-column label="作业地点" show-overflow-tooltip prop="address"></el-table-column>
          <el-table-column label="作业日期" show-overflow-tooltip prop="orderDate"></el-table-column>
          <el-table-column label="工单状态" show-overflow-tooltip prop="machineryModel">
            <template v-slot="{ row }">{{ row.orderStatus | orderStatus }}</template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div  class="selction_info flex" v-else>
          <div  class="no-data" >
              <img src="@/assets/img/empty.svg"/>
          </div>
        </div> -->

    </div>
    <div class="selction">
      <div class="selction_title">
        <div class="left">
          <img src="@/assets/img/statement/taiban.svg" />
          机械台班
        </div>
      </div>
      <!-- v-if="taiBanList.length" -->
      <div class="selction_info ">
        <!-- <div> -->
        <el-table class="global-table global-tables custom-table-border" max-height="208" :data="taiBanList" border
          ref="table_tomorrow">
          <el-table-column label="机械名称" show-overflow-tooltip prop="machineryName"></el-table-column>
          <el-table-column label="规格型号" show-overflow-tooltip prop="specificationModel"></el-table-column>
          <el-table-column label="台班数量" show-overflow-tooltip prop="teamNum"></el-table-column>
          <el-table-column label="台班金额" show-overflow-tooltip prop="teamAmount"></el-table-column>
        </el-table>

      </div>
      <!-- <div  class="selction_info flex" v-else>
          <div  class="no-data" >
              <img src="@/assets/img/empty.svg"/>
          </div>
        </div> -->
    </div>
    <div class="selction" style="margin-bottom:0">
      <div class="selction_title">
        <div class="left">
          <img src="@/assets/img/statement/tommrow.svg" />
          明日计划
        </div>
      </div>
      <div class="selction_info">
        <!-- <div v-if="tomorrowOrderList.length"> -->
        <el-table class="global-table global-tables custom-table-border" max-height="208" :data="tomorrowOrderList"
          border ref="table_tomorrow">
          <el-table-column label="工单详情" show-overflow-tooltip prop="orderContent"></el-table-column>
          <el-table-column label="作业地点" show-overflow-tooltip prop="address"></el-table-column>
          <el-table-column label="指派处理人" show-overflow-tooltip prop="orderUserName"></el-table-column>
        </el-table>

        <!-- </div>
          <div v-else class="no-data" >
              <img src="@/assets/img/empty.svg"/>
          </div> -->

      </div>
    </div>
    <!-- </el-form> -->
  </div>
</template>

<script>
// import * as echarts from 'echarts'
import { px2vw } from '@/utils/util'
export default {
  name: 'AddMaintenanceDay',
  filters: {
    orderStatus: function (value) {
      if (value) {
        if (value === '0') {
          return '待反馈'
        } else if (value === '1') {
          return '待审核'
        } else if (value === '2') {
          return '已完成'
        } else if (value === '3') {
          return '已关闭'
        } else {
          return '--'
        }
      }
    },
    previewList: function (value) {
      return value.map((item) => {
        return item.filePrefix + item.fileUrl
      })
    },
    getStatusName: function (value) {
      // 签到状态 1正常 2缺上班签到 3缺下班签到 4上下班人数不一致
      if (value) {
        if (value === '1') {
          return '正常'
        } else {
          return '异常'
        }
      }
    },
    getStatusName2: function (value) {
      if (value) {
        if (value === '1') {
          return '正常'
        } else if (value === '2') {
          return '缺上班签到'
        } else if (value === '3') {
          return '缺下班签到'
        } else if (value === '4') {
          return '上下班人数不一致'
        } else {
          return '--'
        }
      }
    }
  },
  props: {
    dailyId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      info: {
        projectId: '', // 项目ID
        dailyDate: '', // 日报日期
        manageUserIds: [], // 项目管理人员IDS
        dailyBak: '' // 今日总结
      },
      orderCount: 0,
      activeName: '1',
      orderIdList: [], // 养护工单IDS
      tomorrowOrderList: [], // 明日工单列表
      attendanceList: [], // 劳务考勤列表
      materialList: [], // 物料列表
      taiBanList: [], // 台班列表materiaPression = false // 物料权限
      materiaPression: false, // 物料权限
      orderPression: false, // 工单权限
      dailyBakPression: false, // 今日总结权限
      themeColor: ''
    }
  },
  computed: {
    projectId() {
      return this.$store.state.projectId
    },
    theme() {
      return this.$store.state.theme
    }
  },
  watch: {
    dailyId: {
      handler() {
        this.getMaintenanceDayDetails()
      },
      immediate: true
    },
    theme() {
      // this.setTheme()
    }
  },
  created() {
  },
  mounted() {
    // this.setTheme()
  },
  destroyed() {
    this._chart && this._chart.dispose()
  },
  methods: {
    getMaintenanceDayDetails() {
      this.$axios.get(this.$apis.statement.selectYhProjectDailyByDailyId, {
        dailyId: this.dailyId
      }).then(res => {
        this.info = res
        this.getAttendance() // 查询项目日报-劳务考勤
        this.getDailyOrder() // 查询项目日报-养护作业
        this.getTaiBan()
        this.getTomorrowPlan() // 查询项目日报-明日计划
      })
    },
    getAttendance() {
      this.$axios.get(this.$apis.statement.selectLabourServiceStatisticByDaily, {
        projectId: this.projectId,
        attendanceDate: this.info.dailyDate
      }).then(res => {
        // console.log('劳务考勤', res)
        this.attendanceList = res.attendanceList
      })
    },
    getDailyOrder() {
      this.$axios.get(this.$apis.statement.selectDailyOrder, {
        dailyId: this.dailyId
      }).then(res => {
        // console.log('res222', res)
        this.orderIdList = res.orderlist
        this.orderCount = res.orderCount
        this.$nextTick(() => {
          this.getConserveEchars(res.completeOrderCount, res.unCompleteOrderCount, res.orderCount)
        })
      })
    },
    getTomorrowPlan() {
      this.$axios.get(this.$apis.statement.selectDailyTomorrowPlan, {
        dailyId: this.dailyId
      }).then(res => {
        // console.log('res', res)
        this.tomorrowOrderList = res.orderList
        AMap.plugin('AMap.Geocoder', () => {
          // 根据所选区域初始化项目经纬度
          const geocoder = new AMap.Geocoder()
          this.tomorrowOrderList.forEach(item => {
            geocoder.getAddress([Number(item.longitude), Number(item.latitude)], (status, result) => {
              if (status === 'complete' && result.info === 'OK') {
                item.address = result.regeocode.formattedAddress
              }
            })
          })
        })
      })
    },
    // 养护工单
    getConserveEchars(finished, unfinished, total) {
      // console.log('工单echars', finished, unfinished, total)
      let rate = '0%'
      if (total !== 0) {
        rate = ((finished / total) * 100).toFixed(1) + '%'
      }
      // const rate = ((finished / total) * 100).toFixed(1) + '%'
      // console.log('rate', rate)
      // 基于准备好的dom，初始化echarts实例
      // const myChart: any = echarts.init(document.getElementById('conserve_echars'));
      // console.log('total', total)
      const myChart = echarts.init((this.$refs.conserve_echars))

      const option = {
        graphic: [{ // 环形图中间添加文字
          type: 'text', // 通过不同top值可以设置上下显示
          left: '42%',
          top: '43%',
          style: {
            text: '完成率' + '\n' + `${rate}`,
            textAlign: 'center',
            // fill: '#1E7CE8', // 文字的颜色
            fontSize: px2vw(12),
            lineHeight: px2vw(16)
          },
          label: {
            position: 'center',
            show: true,
            // formatter: () => {
            //   const str = '总风险数' + '\n' + `${this.riskAll}`
            //   return str
            // },
            // color: '#1E7CE8',
            lineHeight: px2vw(16),
            fontSize: px2vw(12)
          }
        }],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '0%',
          left: 'center'
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['40%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: px2vw(10),
              borderColor: '#fff',
              borderWidth: px2vw(2)
            },
            label: {
              show: false,
              position: 'center',
              normal: {
                // \n可让文字居于牵引线上方，很关键
                //  {b}  代表显示的内容标题
                // {c}代表数据
                // formatter: ' {b}：{c} \n',
                formatter: '', // 先不显示
                borderWidth: px2vw(20),
                borderRadius: px2vw(4),
                padding: [0, -80],
                rich: {
                  a: {
                    color: '#333',
                    fontSize: px2vw(12),
                    lineHeight: px2vw(20)
                  },
                  b: {
                    fontSize: px2vw(12),
                    lineHeight: px2vw(20),
                    color: '#333'
                  }
                }
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: finished, name: '已完成' },
              { value: unfinished, name: '未完成' }
            ]
          }
        ]
      }
      // 绘制图表
      myChart.setOption(option)
    },
    // 获取台班
    getTaiBan() {
      this.$axios.get(this.$apis.statement.selectJgMachineryTeamByList, {
        projectId: this.projectId,
        machineTeamDate: this.info.dailyDate
      }).then(res => {
        // console.log('劳务考勤', res)
        this.taiBanList = res.list
      })
    }
  }
}
</script>

<style scoped lang="scss">
.radioGroup {
  margin: 0 0 15px;
  height: 36px;
  line-height: 36px;

  .el-radio-button {
    height: 30px;
    line-height: 30px;
  }
}

::v-deep .textarea {
  width: 70%;
}

::v-deep .el-form {
  padding: 0 30px
}

::v-deep .el-card__body {
  padding: 0;
  font-size: 14px;
}

::v-deep .el-input__inner {
  padding-right: 50px;
}

.flex {
  display: flex;
}

.my-table {
  display: inline-block;
  width: calc(100% - 210px);
}

.item-line {
  display: flex;
  flex-wrap: wrap;
  height: 32px;

  // margin-bottom:10px;
  &>div {
    margin-right: 250px;
  }
}

.el-dialog__body {
  color: var(--font-color) !important;
}

.table {
  // padding-left: 20px;

  .instructions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
    }
  }

  p .cell.el-tooltip {
    white-space: unset !important;
  }

  ::v-deep .el-form-item__error {
    position: unset;
  }

  .cell {
    overflow: unset;
  }

  .el-select {
    width: auto;
  }

  ::v-deep .el-input {
    width: calc(100% - 20px);
  }
}

.header {
  height: 210px;
  padding: 35px 40px;
  display: flex;
  // box-shadow: 0px 2px 8px 0px rgba(139,172,237,0.2);
  border-radius: 20px;
  border: 1px solid #E3E3E3;

  .img_logo {
    width: 240px;
    height: 140px;
    border-radius: 8px;
    border: 2px solid #57AEFE;
    margin-right: 24px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .header_info {
    flex: 1;

    .title {
      height: 45px;
      line-height: 45px;
      font-size: 26px;
      // font-family: AlimamaShuHeiTi-Bold, AlimamaShuHeiTi;
      font-weight: bold;
    }

    .date {
      display: flex;
      align-items: center;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;

      .item {
        display: flex;
        align-items: center;

        img {
          margin-right: 5px;
        }
      }
    }

    .evaluation {
      height: 26px;
      line-height: 26px;
      font-size: 18px;
      margin-top: 20px;
      // font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      display: flex;
      align-items: center;

      .star {
        margin-right: 5px;
        width: 26px;
        height: 26px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .grade {
        font-size: 30px;
        font-weight: bold;
        color: #00A870;
        // line-height: 32px;
        margin-left: 5px;
      }
    }

    span {
      margin: 0 15px
    }
  }

}

.selction {
  // box-shadow: 0px 2px 8px 0px rgba(139,172,237,0.2);
  border-radius: 20px;
  border: 1px solid #E3E3E3;
  margin-bottom: 20px;

  .selction_title {
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E3E3E3;
    font-weight: 500;
    font-size: 18px;

    .left {
      margin-left: 40px;
      line-height: 54px;
      height: 54px;
      display: flex;
      align-items: center;

      img {
        margin-right: 5px;
      }
    }

    .right {
      display: flex;
      margin-right: 20px;
      align-items: center;
    }

    .more {
      font-size: 14px;
      font-weight: bold;
      color: #5750EB;
      margin-left: 12px;
    }
  }

  .selction_info {
    padding: 36px 40px;

    .count {
      position: absolute;
      top: 15px;
      left: 40px;
      font-size: 14px;
      // font-weight: 500;
    }

    .user_list {
      height: 64px;
      display: flex;
      width: 100%;
      overflow-x: auto;

      img {
        width: 64px;
        height: 64px;
        border-radius: 32px;
        margin-right: 10px;
      }

      .user_item {
        display: flex;
        align-items: center;
        margin-right: 40px;
      }
    }
  }

  .selction_info_material {
    padding: 24px 40px 36px !important;
  }

}

#conserve_echars {
  width: 210px;
  height: 200px;
  display: inline-block;
}

#material_echars {
  width: 210px;
  height: 200px;
  display: inline-block;
}

.position_relative {
  position: relative
}

.no-data {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  // margin-top: 30px;
  img {
    width: 150px;
  }

  span {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 22px;
    margin-bottom: 30px;
  }
}
</style>
